'use strict';

angular.module('otpp-feature-toggles').provider('featureToggles', function() {
  var features = {};

  function setFeatures(featureToggles) {
    angular.forEach(featureToggles, function(featureConfig, featureName) {
      setFeature(featureName, featureConfig);
    });
  };

  function setFeature(featureName, featureConfig) {
    if (features[featureName]) {
      features[featureName] = angular.merge({}, features[featureName], featureConfig);
    } else {
      features[featureName] = featureConfig;
    }
  }

  return {
    setFeatures: setFeatures,
    setFeature: setFeature,
    $get: function($log) {
      return {
        isEnabled: isEnabled,
        getAllFeatures: getAllFeatures
      };

      function getAllFeatures() {
        return angular.copy(features);
      }

      function isEnabled(featureName) {
        if (!features[featureName]) {
          $log.warn('Feature "' + featureName + '" is not configured and will be disabled by default.');
          return false;
        }
        return features[featureName].enabled;
      }
    }
  };
});
